import Loadable from '@townsquare/loadable';
import { readingModeRoute } from '@townsquare/routes/reading-mode-view';

import { readingModeResource } from './resources/readingMode';

// Reading Mode View
const ReadingModeViewLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "reading-mode-view" */ './ui/index'),
  loading: () => null,
});

readingModeRoute.component = ReadingModeViewLoadable;
readingModeRoute.resources = [readingModeResource];
export const readingModeRouterRoute = readingModeRoute;
